module.exports = __webpack_public_path__ + "static/media/pt-logo.2caaeaa3.svg";